import { applicantStatusTypes } from '../constants/statusConstants';
import { gql } from '@apollo/client';
import {
  RP_COMPLETE_TRACKING_LABEL,
  RP_INCOMPLETE_TRACKING_LABEL,
  RP_NOT_IDENTIFIED_TRACKING_LABEL,
} from '../constants/rentGuarantee';
import { isFuture } from 'date-fns';

const doCompletedApplicantsHaveDocuments = (applicants, isAlwGraph = false) =>
  applicants
    .filter((applicant) => applicant.status === applicantStatusTypes.COMPLETED.id)
    .flatMap((applicant) => (isAlwGraph ? applicant.currentIncomes : applicant.answers.currentIncomes))
    .flatMap((currentIncome) => currentIncome.documents)
    .some((document) => isFuture(isAlwGraph ? document.expirationDateUtc : document.expirationDateTime));

export const getHasReviewableDocuments = (rentalListing) =>
  rentalListing.isRentGuaranteeEnabled &&
  doCompletedApplicantsHaveDocuments(rentalListing.landlordRentalApplication.applicants);

export const getHasReviewableDocumentsByApplicationId = (rentalListing, applicationId) => {
  const targetApplication = rentalListing?.landlordRentalApplications?.find(
    (application) => application.id === applicationId,
  );
  return rentalListing.isRentGuaranteeEnabled && doCompletedApplicantsHaveDocuments(targetApplication.applicants);
};

export const getSummaryPageTrackingLabel = (rentalListing, needsToIdVerify = false) => {
  const { isRentGuaranteeEnabled, landlordRentalApplication } = rentalListing;

  if (!isRentGuaranteeEnabled) {
    return '';
  }

  if (needsToIdVerify) {
    return RP_NOT_IDENTIFIED_TRACKING_LABEL;
  }

  return doCompletedApplicantsHaveDocuments(landlordRentalApplication.applicants)
    ? RP_COMPLETE_TRACKING_LABEL
    : RP_INCOMPLETE_TRACKING_LABEL;
};

export const getIsRentGuaranteeEnabled = (property) => Boolean(property?.rentGuarantee?.isRentGuaranteeEnabled);
export const getIsRentGuaranteeEligible = (property) => Boolean(property?.rentGuarantee?.isRentGuaranteeEligible);

export const getIsIncomeToRentEligible = (property) =>
  Boolean(
    getIsRentGuaranteeEnabled(property) &&
      property?.rentGuarantee?.isIncomeToRentVerified &&
      property?.rentGuarantee?.isIncomeToRentEligible,
  );

export const getHasUploadedHousingVouchers = (applicants) =>
  Boolean(
    applicants
      .filter((applicant) => applicant.status === applicantStatusTypes.COMPLETED.id)
      .flatMap((applicant) => applicant.answers.currentIncomes)
      .filter((currentIncome) => currentIncome.type === 'voucher')
      .some((currentIncome) => currentIncome.documents.length > 0),
  );

export const INCOME_TO_RENT_ELIGIBLE_MUTATION = gql`
  mutation IncomeToRentEligible($listingAlias: ID!, $applicationId: ID!, $incomeToRentEligible: Boolean!) {
    markIncomeToRentEligible(
      listingAlias: $listingAlias
      applicationId: $applicationId
      incomeToRentEligible: $incomeToRentEligible
    ) {
      id
      isIncomeToRentEligible
      isIncomeToRentVerified
    }
  }
`;

export const SEND_INELIGIBLE_TENANT_INVITED_NOTIFICATION = gql`
  mutation sendIneligibleTenantInvitedNotification($listingAlias: String!) {
    sendIneligibleTenantInvitedNotification(listingAlias: $listingAlias) {
      success
    }
  }
`;
